<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
        <v-icon>dynamic_feed</v-icon>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;Manejo de Reclamos</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)">
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col>
            <v-autocomplete
              v-model="filtro.empresaId"
              :items="empresas"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="De la Empresa"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-select
              label="Analista:"
              v-model="filtro.analistaLogin"
              :items="analistas"
              item-text="login"
              item-value="id"></v-select>
          </v-col>
          <v-col>
            <app-selector-periodos
              v-on:update-periodo="
                filtro.periodo = $event
              "></app-selector-periodos>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="2">
            <v-text-field
              v-model="filtro.cui"
              label="Buscar por documento"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              label="Estado:"
              v-model="filtro.estadoId"
              :items="estados"
              autocomplete="disabled"
              item-text="descripcion"
              item-value="id"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"></v-autocomplete>
          </v-col>

          <v-col cols="3">
            <v-autocomplete
              label="Canal:"
              v-model="filtro.canalId"
              :items="canales"
              autocomplete="disabled"
              item-text="descripcion"
              item-value="id"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"></v-autocomplete>
          </v-col>

          <v-col cols="3">
            <v-autocomplete
              label="Motivo:"
              v-model="filtro.motivoId"
              :items="motivos"
              autocomplete="disabled"
              item-text="descripcion"
              item-value="id"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"></v-autocomplete>
          </v-col>

          <v-col cols="3">
            <v-autocomplete
              label="Estado Bcra:"
              v-model="filtro.estadoBcra"
              :items="estadoBcra"
              autocomplete="disabled"
              item-text="nombre"
              item-value="status"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"></v-autocomplete>
          </v-col>
          <v-col>
            <v-checkbox
              label="Filtrar por Fecha de Cierre"
              v-model="filtro.filtrarPorFechaCierre"></v-checkbox>
            <app-selector-periodos
              v-if="filtro.filtrarPorFechaCierre"
              v-on:update-periodo="
                filtro.periodoCierre = $event
              "></app-selector-periodos>
          </v-col>
          <v-col cols="2">
            <v-btn color="success" @click="getItems(true)" :disabled="loading"
              >Consultar</v-btn
            >
          </v-col>
        </v-row>
        <v-flex>
          <v-card>
            <v-toolbar dense :color="$store.state.UiColors.crudToolbarList">
              <v-icon>list</v-icon>
              <v-toolbar-title class="font-weight-light">Lista</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-data-table
              loading-text="Buscando registros"
              dense
              :headers="headers"
              :items="records"
              :rows-per-page="pagination.itemsPerPage"
              :options.sync="pagination"
              v-model="selectedRows"
              :loading="loading"
              class="elevation-1"
              :footer-props="footer"
              item-key="id">
              <template slot="no-data">
                <v-alert :value="true" color="grey" icon="warning">
                  No se encontraron registros con los filtros ingresados
                </v-alert>
              </template>

              <template v-slot:item="{ item }">
                <tr>
                  <td class="text-xs-left caption">
                    {{ item }}
                  </td>
                  <td>
                    <app-acciones-comunes :personaId="item.solicitanteId" />
                  </td>
                  <td class="text-xs-left caption">{{ item.solicitante }}</td>
                  <td class="text-xs-left caption">{{ item.motivoReclamo }}</td>
                  <td class="text-xs-left caption">
                    {{ item.estado }}
                    <v-btn
                      v-if="item.estadoBcra != 'Cerrado'"
                      dark
                      x-small
                      color="green"
                      @click="changeState(item)"
                      >Cambiar</v-btn
                    >
                    <v-btn
                      v-if="
                        item.estadoBcra == 'Cerrado' &&
                        checkCanAccess('ap-reabrir-reclamo')
                      "
                      dark
                      x-small
                      color="indigo"
                      @click="changeState(item)"
                      >Reabrir</v-btn
                    >
                  </td>
                  <td class="text-xs-left caption">
                    {{ "$" + item.montoDevolucion }}
                  </td>

                  <td class="text-xs-left caption">
                    {{
                      item.fechaDevolucion
                        | dateParse("YYYY-MM-DD")
                        | dateFormat("DD-MM-YYYY")
                    }}
                  </td>

                  <td class="text-xs-left caption">{{ item.cuil }}</td>
                  <td class="text-xs-left caption">{{ item.nroCredito }}</td>
                  <td class="text-xs-left caption">{{ item.numeroReclamo }}</td>
                  <td class="text-xs-left caption">
                    {{
                      item.fechaIngreso
                        | dateParse("YYYY-MM-DD")
                        | dateFormat("DD-MM-YYYY")
                    }}
                  </td>
                  <td class="text-xs-left caption">{{ item.estadoBcra }}</td>
                  <td class="text-xs-left caption">
                    <!-- Otras Entidades Involucradas -->
                    <!-- leave empty or render something -->
                  </td>
                  <td
                    class="text-xs-left caption"
                    v-if="item.fechaCierre != '0001-01-01T00:00:00'">
                    {{
                      item.fechaCierre
                        | dateParse("YYYY-MM-DD")
                        | dateFormat("DD-MM-YYYY")
                    }}
                  </td>
                  <td class="text-xs-left caption" v-else>-</td>
                  <td class="text-xs-left caption">
                    <v-chip small :color="item.empresaColor" label dark>{{
                      item.empresaShort
                    }}</v-chip>
                  </td>

                  <td class="text-xs-left caption">{{ item.telefono }}</td>

                  <td class="text-xs-left caption">{{ item.email }}</td>
                </tr>
              </template>
            </v-data-table>
            <v-row dense>
              <v-col>
                <v-btn @click.stop="altaReclamo()" color="blue" dark>
                  Dar de Alta un nuevo Reclamo</v-btn
                >
                &nbsp;
              </v-col>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark color="green" @click="generarArchivo">
                  Descargar&nbsp;
                  <v-icon>cloud_download</v-icon>
                </v-btn>
              </v-card-actions>
            </v-row>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
    <div></div>
    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>

      Model: {{ filtro }}
      <p></p>
    </template>
  </v-container>
</template>

<script>
import { http } from "@/axios";
//import Vue from "vue";
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from "vuex";

export default {
  data() {
    return {
      showSaveProgress: false,
      saving: false,
      downloading: false,
      primeraBusquedaRealizada: false,
      loading: false,
      editMode: false,
      suspend: false,
      filterChanged: false,
      search: "", // valor para búsqueda
      pagination: {
        // definición de paginación
        sortDesc: [true],
        sortBy: [""],
        page: 1,
        itemsPerPage: 5,
      },
      footer: {
        showFirstLastPage: true,
        //itemsPerPageOptions:[5,10,20, 50, 'All'],
        showCurrentPage: true,
      },
      totalItems: 0, // va afuera de pagination
      headers: [
        // definición de columnas
        { text: "Ver", value: "accion", width: 80, sortable: false },
        { text: "Solicitante Reclamo", value: "solicitante" },
        { text: "Motivo", value: "motivoReclamo", width: 150 },
        { text: "Estado", value: "estado" },
        { text: "Devolución", value: "montoDevolucion", width: 130 },
        { text: "Fecha Reintegro", value: "fechaDevolucion", width: 130 },
        { text: "Cuil", value: "cuil" },
        { text: "Nº Crédito", value: "nroCredito" },
        { text: "Nº Reclamo", value: "numeroReclamo" },
        { text: "Fecha Ingreso", value: "fechaIngreso", width: 130 },
        { text: "Estado BCRA", value: "estadoBCRA", width: 130 },
        { text: "Otras Entidades Involucradas", value: "otrasEntidades" },
        { text: "Fecha Cierre", value: "fechaCierre" },
        { text: "Empresa", value: "empresaShort", width: 100 },
        { text: "Teléfono", value: "telefono", width: 100 },
        { text: "Email", value: "email", width: 100 },
      ],
      records: [], // registros
      selectedRows: [],
      filtro: {
        marcaDefinitiva: true,
        analistaLogin: "00000000-0000-0000-0000-000000000000",
        estadoId: 0,
        estadoBcra: 0,
        empresaId: 0,
        periodo: { id: 1 },
        periodoCierre: { id: 1 },
        filtrarPorFechaCierre: false,
        canalId: 0,
        motivoId: 0,
      },
      filtroArchivo: {
        empresaId: 0,
        analistaId: "00000000-0000-0000-0000-000000000000",
        fechaDesde: "",
        fechaHasta: "",
        filtrarPorFechaCierre: "",
        fechaCierreDesde: "",
        fechaCierreHasta: "",
        documento: "",
        estadoId: 0,
        estadoBcra: 0,
        canalId: 0,
        motivoId: 0,
        sortBy: "",
        separador: ";",
      },
      estadoBcra: [
        { nombre: "Cualquiera", status: 0 },
        { nombre: "Abierto", status: 1 },
        { nombre: "Cerrado", status: 2 },
      ],
      empresas: [],
      analistas: [],
      estados: [],
      canales: [],
    };
  },
  async created() {
    this.loadEmpresas();
    this.loadEstados();
    this.loadAnalistas();
    this.loadCanales();
    this.loadMotivos();
    //this.loadMotivosReintegro();
  },
  watch: {
    /* pagination :{
        handler(){
          if(this.primeraBusquedaRealizada)
            this.getItems(false);
        },
        deep: true
    }, */
    search() {
      this.getItems(true);
    },
  },
  computed: {
    ...mapGetters(["getActionFromLink", "user", "checkCanAccess"]),
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
    formatoSeleccionado() {
      if (!this.filtro.formatoId) return null;
      console.log(
        this.formatos.filter((e) => e.id == this.filtro.formatoId)[0],
      );
      return this.formatos.filter((e) => e.id == this.filtro.formatoId)[0];
    },
  },
  methods: {
    ...mapMutations([
      "setActiveTask",
      "setActiveSubTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
      "setReporteActivo",
    ]),
    ...mapActions(["setStatusTareaFrecuente"]),
    selectAllChanged(toggle) {
      this.selectedRows = [];
      if (toggle) {
        for (let index = 0; index < this.records.length; index++) {
          const element = this.records[index];

          this.selectedRows.push(element);
        }
      }
    },
    async getItems(resetPagination) {
      // if (this.filtro.empresaId == 0) {
      //   this.alertWarning("Debe elegir una Empresa.");
      //   return;
      // }
      //Hago esto para que si cambias los filtros y tocas consultar traiga los resultados de la primera página
      if (resetPagination) {
        this.pagination.page = 1;
      }

      this.loading = true;
      this.$validator.reset();

      let filter = this.filtro;
      try {
        var result = await http.get(
          "reclamos/list/reclamosfiltrados?empresaId=" +
            filter.empresaId +
            "&analistaId=" +
            filter.analistaLogin +
            "&fechaDesde=" +
            filter.periodo.desde +
            "&fechaHasta=" +
            filter.periodo.hasta +
            "&filtrarPorFechaCierre=" +
            filter.filtrarPorFechaCierre +
            "&fechaCierreDesde=" +
            (filter.filtrarPorFechaCierre
              ? filter.periodoCierre.desde
              : filter.periodo.desde) +
            "&fechaCierreHasta=" +
            (filter.filtrarPorFechaCierre
              ? filter.periodoCierre.hasta
              : filter.periodo.hasta) +
            "&documento=" +
            filter.cui +
            "&estadoId=" +
            filter.estadoId +
            "&estadoBcra=" +
            filter.estadoBcra +
            "&canalId=" +
            filter.canalId +
            "&motivoId=" +
            filter.motivoId,
        );

        this.selectedRows = [];
        this.records = result.list;
        this.totalItems = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.primeraBusquedaRealizada = true;
      this.loading = false;
    },

    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get(
          "empresas/list/porusuario?usuarioId=" + this.user.id,
        );

        this.empresas = result.list;
        this.empresas.unshift({ id: 0, nombre: "(Cualquiera)" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadAnalistas() {
      this.loading = true;
      try {
        var result = await http.get("usuarios/listByRol?rolId=3"); //traigo los usuarios con rol analista

        this.analistas = result.list;

        this.analistas.unshift({
          id: "00000000-0000-0000-0000-000000000000",
          login: "(Todos)",
        });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadEstados() {
      this.loading = true;
      try {
        var result = await http.get("reclamos/list/tipoaccionesreclamo");

        this.estados = result.list;

        this.estados.unshift({ id: 0, descripcion: "(Cualquiera)" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCanales() {
      this.loading = true;
      try {
        var result = await http.get("reclamos/list/tipocanalesreclamo");

        this.canales = result.list;

        this.canales.unshift({ id: 0, descripcion: "(Cualquiera)" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadMotivos() {
      this.loading = true;
      try {
        var result = await http.get("reclamos/list/tipomotivosreclamo");

        this.motivos = result.list;

        this.canales.unshift({ id: 0, descripcion: "(Cualquiera)" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    // async loadMotivosReintegro() {
    //   this.loading = true;
    //   try {
    //     var result = await http.get("reclamos/list/tipomotivosreintegro");

    //     this.motivosReintegro = result.list;

    //     this.canales.unshift({ id: 0, descripcion: "(Cualquiera)" });
    //   } catch (error) {
    //     // Error
    //     this.alertError(error);
    //   }
    //   this.loading = false;
    // },

    async generarArchivo() {
      var self = this;
      let filter = this.filtro;
      let filterFile = this.filtroArchivo;

      //alert(filter.periodo.fechaDesde);

      filterFile.empresaId = filter.empresaId;
      filterFile.analistaId = filter.analistaLogin;
      filterFile.fechaDesde = filter.periodo.desde;
      filterFile.fechaHasta = filter.periodo.hasta;
      filterFile.filtrarPorFechaCierre = filter.filtrarPorFechaCierre;

      if (filter.filtrarPorFechaCierre) {
        filterFile.fechaCierreDesde = filter.periodoCierre.desde;
      } else {
        filterFile.fechaCierreDesde = filter.periodo.desde;
      }

      if (filter.filtrarPorFechaCierre) {
        filterFile.fechaCierreHasta = filter.periodoCierre.hasta;
      } else {
        filterFile.fechaCierreHasta = filter.periodo.hasta;
      }

      filterFile.documento = filter.cui;
      filterFile.estadoId = filter.estadoId;
      filterFile.estadoBcra = filter.estadoBcra;
      filterFile.canalId = filter.canalId;
      filterFile.motivoId = filter.motivoId;

      var params = {
        empresaId: filter.empresaId,
        analistaId: filter.analistaLogin,
        fechaDesde: filter.periodo.desde,
        fechaHasta: filter.periodo.hasta,
        filtrarPorFechaCierre: filter.filtrarPorFechaCierre,
        fechaCierreDesde: filterFile.fechaCierreDesde,
        fechaCierreHasta: filterFile.fechaCierreHasta,
        documento: filter.cui,
        estadoId: filter.estadoId,
        estadoBcra: filter.estadoBcra,
        canalId: filter.canalId,
        motivoId: filter.motivoId,
        sortBy: "",
        separador: ";",
      };

      //alert(params.documento);

      try {
        self.loading = true;
        await http
          .post(
            "FileGeneration/archivoreclamos",
            JSON.stringify({ parametros: params }),
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Se generó correctamente el archivo. Aguarde unos instantes mientras se descarga el archivo...",
              );

              self.loading = true;
              self.downloadFile(resp, "ArchivoReclamos.csv");
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }

      self.loading = false;
    },
    async downloadFile(file, renameTo) {
      //convierto el string del path a base64 para poder mandarlo
      let base64String = "";
      base64String = btoa(file.fullPath);

      http
        .get("filemanagement/getfilebypath/" + base64String)
        .then((resp) => {
          let dataType = "";
          switch (resp.extension) {
            case ".doc":
            case ".docx":
            case ".DOC":
            case ".DOCX":
              dataType = "data:application/vnd.ms-word";
              break;
            case ".pdf":
            case ".PDF":
              dataType = "data:application/pdf";
          }

          //necesito hacer esto del arrayBuffer para que despues se pueda hacer el blob
          var arrayBuffer = this.base64ToArrayBuffer(resp.file);
          this.saveByteArray(renameTo, arrayBuffer, dataType);
        })
        .catch((e) => this.alertError(e));
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(fileName, byteArrayBuffer, dataType) {
      var blob = new Blob([byteArrayBuffer], { type: dataType });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
    altaReclamo() {
      var params = {
        width: 900,
        visible: true,
      };

      this.setActiveTask({ task: "app-alta-reclamo", props: params });
    },
    changeState(item) {
      var params = {
        width: 900,
        visible: true,
        reclamo: item,
      };

      this.setActiveTask({ task: "app-modifica-reclamo", props: params });
    },
  },
};
</script>
